<div class="vl-planning" aria-label="Planning" role="region">

  <div class="vl-planning__strip-wrapper">
    <!-- Flèche gauche -->
    <button type="button" class="vl-planning__nav" aria-label="Jour précédent" (click)="shiftBack()">‹</button>

    <!-- Bande de cellules -->
    <div class="vl-planning__strip" role="list">
      @for (cell of cells(); track cell.key) {
        <vl-planning-list-cell
          role="listitem"
          [cell]="cell"
          [comfortable]="activeComfortable()"
          [stretchEmpty]="isSparseView()"
          (cellClick)="onCellClick($event)"
          (eventClick)="onEventClick($event)" />
      }
    </div>

    <!-- Flèche droite -->
    <button type="button" class="vl-planning__nav" aria-label="Jour suivant" (click)="shiftForward()">›</button>

    <!-- Colonne actions (today + settings stackés verticalement) pour gagner
         de la largeur horizontale et libérer de la place pour les cellules. -->
    <div class="vl-planning__actions">
      @if (rangeShift() !== 0) {
        <button type="button" class="vl-planning__today-btn"
                aria-label="Recentrer sur aujourd'hui"
                matTooltip="Revenir à aujourd'hui"
                (click)="resetShift()">
          <mat-icon>today</mat-icon>
        </button>
      }
      <button type="button" class="vl-planning__settings-btn"
              [matMenuTriggerFor]="settingsMenu" aria-label="Réglages">
        <mat-icon>tune</mat-icon>
      </button>
    </div>
  </div>
</div>

<!-- Menu réglages -->
<mat-menu #settingsMenu="matMenu" class="vl-planning-settings-menu">
  <div class="vl-planning-settings" (click)="$event.stopPropagation()">
    <div class="vl-planning-settings__group">
      <span class="vl-planning-settings__label">Jours passés</span>
      <div class="vl-planning-settings__options">
        @for (n of offsetOptions; track n) {
          <button type="button"
                  class="vl-planning-settings__chip"
                  [class.vl-planning-settings__chip--active]="activeTodayOffset() === n"
                  (click)="setTodayOffset(n)">
            {{ n === 0 ? 'Aucun' : n + 'j' }}
          </button>
        }
      </div>
    </div>

    <div class="vl-planning-settings__group">
      <span class="vl-planning-settings__label">Prépa PDC (avant lancement)</span>
      <div class="vl-planning-settings__options">
        @for (n of pdcPrepaOptions; track n) {
          <button type="button"
                  class="vl-planning-settings__chip"
                  [class.vl-planning-settings__chip--active]="activePdcPrepaOffset() === n"
                  (click)="setPdcPrepaOffset(n)">
            {{ n === 0 ? 'Jour J' : 'J-' + n }}
          </button>
        }
      </div>
    </div>

    @if (effectiveSourceMeta().length > 1) {
      <div class="vl-planning-settings__group">
        <span class="vl-planning-settings__label">Sources affichées</span>
        <div class="vl-planning-settings__options vl-planning-settings__options--wrap">
          @for (meta of effectiveSourceMeta(); track meta.key) {
            <button type="button"
                    class="vl-planning-settings__chip vl-planning-settings__chip--source"
                    [class]="'vl-planning-settings__chip--' + meta.key"
                    [class.vl-planning-settings__chip--source-off]="isSourceHidden(meta.key)"
                    (click)="toggleSourceHidden(meta.key)">
              <mat-icon class="vl-planning-settings__chip-icon">{{ meta.icon }}</mat-icon>
              {{ meta.label }}
            </button>
          }
        </div>
      </div>
    }
  </div>
</mat-menu>
